import React from 'react';
import styled from 'styled-components';
import { Language } from '../types';
import { theme } from '../styles/theme';
import LanguageSelector from './LanguageSelector';

const HeaderContainer = styled.header`
  background: ${theme.colors.primary};
  color: ${theme.colors.onPrimary};
  padding: ${theme.spacing(3)} ${theme.spacing(2)};
  box-shadow: ${theme.elevation[4]};

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing(2)} ${theme.spacing(1)};
  }
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing(2)};

  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: ${theme.spacing(2)};
    text-align: center;
  }
`;

const TitleContainer = styled.div`
  flex: 1;
`;

const Title = styled.h1`
  margin: 0;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.h3.fontSize};
  font-weight: ${theme.typography.h3.fontWeight};
  line-height: ${theme.typography.h3.lineHeight};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.h4.fontSize};
  }
`;

const Subtitle = styled.p`
  margin: ${theme.spacing(0.5)} 0 0 0;
  font-size: ${theme.typography.subtitle1.fontSize};
  opacity: 0.9;
  font-weight: ${theme.typography.subtitle1.fontWeight};
  line-height: ${theme.typography.subtitle1.lineHeight};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.subtitle2.fontSize};
  }
`;

const TrainInfo = styled.div`
  background: rgba(255, 255, 255, 0.12);
  padding: ${theme.spacing(1)} ${theme.spacing(2)};
  border-radius: ${theme.shape.borderRadius}px;
  font-size: ${theme.typography.body2.fontSize};
  font-weight: ${theme.typography.subtitle2.fontWeight};
  text-align: center;
  margin-top: ${theme.spacing(1)};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.caption.fontSize};
    padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
  }
`;

interface HeaderProps {
  currentLanguage: Language;
  onLanguageChange: (language: Language) => void;
}

const Header: React.FC<HeaderProps> = ({ currentLanguage, onLanguageChange }) => {

  return (
    <HeaderContainer>
      <HeaderContent>
        <TitleContainer>
          <Title>SJ EuroNight Menu</Title>
          <Subtitle>Onboard Bistro Service</Subtitle>
          <TrainInfo>
            Berlin ↔ Stockholm
          </TrainInfo>
        </TitleContainer>
        <LanguageSelector
          currentLanguage={currentLanguage}
          onLanguageChange={onLanguageChange}
        />
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;